import styled from "styled-components";

export const HelpLinksWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	background: transparent;
	border: none;
  margin-right: 5px;
`;

export const HelpLinksButton = styled.a`
	position: relative;
`